// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3_k6x","label":"CategoryService_label__2qRo0","location":"CategoryService_location__3MNcY"};